@if (trustService.showTrustDialog()) {
  <div class="page">
    <div class="container">
      <div class="extension-dialog" fd-card-list>
        <fd-card
          class="trust-dialog-card"
          role="listitem"
          [interactive]="false"
        >
          <fd-card-content class="trust-dialog-content">
            <h3 class="extension-title">{{ extensionLabel() }}</h3>
            <img
              alt="Sap for Me Warning Logo"
              src="../../../assets/sap_for_me_warning.svg"
            />
            <h2 class="alert">Unverified Extension</h2>
            <p>
              This is a custom extension made for this Workspace, and it has not
              been verified by the Hyperspace Portal. Granting access will give
              custom extensions for this Workspace access to your user account
              data. Only grant access if you trust this source.
            </p>

            <fd-checkbox
              data-testid="dxp-extension-trust-confirm-checkbox"
              label="I confirm that all installed custom extensions for this Workspace will have access to my user account data."
              [required]="true"
              [wrapLabel]="true"
              [(ngModel)]="checkboxValue"
            />
            <button
              data-testid="dxp-extension-trust-confirmation-button"
              fd-button
              fdCompact
              label="Grant Access"
              [disabled]="!checkboxValue"
              (click)="trustService.trustProject()"
            ></button>
          </fd-card-content>
        </fd-card>
      </div>
    </div>
  </div>
}
